module.exports = __webpack_public_path__ + "static/media/horizon_default_compressed.44178019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/horizon_default_compressed.jpg
// module id = 1706
// module chunks = 3